/** A new slip. Nothing is written -- and no number is spent -- until the first Post. */
import { PROCESSING_PACKING_SLIP_FORM } from "@nexseed/shared";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { FormPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { ProcessingSlipPage } from "@/features/processing/components/processing-slip-page";

export const Route = createFileRoute("/_app/processing/packing-slip/new")({
  beforeLoad: () => {
    if (!useAuth.getState().canCreateForm(PROCESSING_PACKING_SLIP_FORM))
      throw redirect({ to: "/processing/packing-slip" });
  },
  component: Page,
});

function Page() {
  const { selected, ready } = useFacilities();
  if (!ready) return <FormPageSkeleton />;
  return (
    <ProcessingSlipPage
      packing
      slip={null}
      facilityId={selected?.id}
      plantName={selected ? `${selected.name} (${selected.plantCode})` : null}
    />
  );
}
